<template>
  <div style="padding: 0 10px">
    <el-tabs v-model="processNode" type="card" @tab-click="handleClick">
      <el-tab-pane :label="`待仓库处理(${countData.warehouseProcessTotal})`" name="3"></el-tab-pane>
      <el-tab-pane :label="`采购处理中(${countData.purchaseProcessTotal})`" name="1"></el-tab-pane>
      <el-tab-pane :label="`客户处理中(${countData.customerProcessTotal})`" name="2"></el-tab-pane>
      <el-tab-pane :label="`已完成(${countData.alreadyProcessTotal})`" name="999"></el-tab-pane>
    </el-tabs>
    <Form layout="code,date,expNo,systemSource,inboundCode,exceptionSource, exceptionCodes,isShortage" @search="search"
      ref="Form"></Form>
    <WmsTable :isPagination="query" :columns="columns" :dataSource="datasource" @pageChange="pageChangeCall"
      :hasHeader="false">
      <div slot="productImg" slot-scope="{text}" style="padding:0">
        <ImgPreviews :images="[text]" v-if="text" :width="50" :height="50"></ImgPreviews>
      </div>
      <div slot="errorImg" slot-scope="{text, record}" style="position: relative;">
        <!-- <ImgPreviews :images="text" v-if="text"></ImgPreviews> -->
        <el-image :src="text?.[0]" style="width:60px;height: 60px;" :preview-src-list="text" alt="图片"
          class="previewsImage-tag" v-if="text?.[0]">
        </el-image>

        <div class="tag-side-content">
          <div v-if="record.imgDTOList?.[0]?.tags?.includes('outside')" class="tag-item">表面</div>
          <div v-if="record.imgDTOList?.[0]?.tags?.includes('inside')" class="tag-item">内里</div>
          <div v-if="record.imgDTOList?.[0]?.tags?.includes('normal')" class="tag-item">正品</div>
          <div v-if="record.imgDTOList?.[0]?.tags?.includes('defective')" class="tag-item">次品</div>
        </div>
      </div>
      <div slot="tag" slot-scope="{text,record}">
        <div v-if="record.exceptionCodes[0] == 103">
          <div v-for="i in record.processResults">{{ `${i.amount}件${i.flowTagName}(${i.pkgCode})` }}</div>
        </div>
        <div v-else-if="record.oemMoreInboundException">
          <div v-for="item in record.processResults">{{ `${item.amount}件${item.flowTagName}(${item.pkgCode})` }}</div>
        </div>
        <div v-else-if="record.tag">
          {{taglist[taglist.findIndex(i => i.value == record.tag)].label}}
        </div>
        <div v-else></div>
      </div>
      <div slot="action" slot-scope="record">
        <a @click="detail(record)">详情</a>
        <a @click="print(record)" style="margin-left:10px">打印</a>
        <a @click="log(record)" style="margin-left:10px">日志</a>
        <el-button @click="changePic(record)" style="margin-left:10px" type="text"
          :disabled="record.record.wareStatus == 1 || record.record.serviceStatus == 1">修改图片</el-button>
      </div>
    </WmsTable>
    <changePic ref="changePic" @update="getDataSource"></changePic>
    <el-dialog title="详情" :visible.sync="dialogVisible">
      <detail ref="detail" @reFreash="getDataSource" @close="dialogVisible = false"></detail>
    </el-dialog>
    <el-dialog :visible="visible" title="日志" width="1000px" @close="visible = false">
      <WmsTable :isPagination="false" :columns="logColumns" :dataSource="logList" :hasHeader="false">
      </WmsTable>
    </el-dialog>
  </div>
</template>

<script>
import Form from "@/views/abnormal/components/form";
import WmsTable from "@/components/WmsTable";
import ImgPreviews from "@/components/ImgPreviews"
import detail from "@/views/abnormal/listDetail/ListDetail";
import changePic from "../components/changePic.vue";
import { columns, taglist, logColumns } from "@/views/abnormal/list/columns";
import { abnormalPage, recordInfo, abnormalCount } from "@/apis/abnormal";

export default {
  name: 'abnormal_list',
  components: { Form, WmsTable, detail, ImgPreviews, changePic },
  props: {},
  data() {
    return {
      processNode: '3',
      columns,
      taglist,
      datasource: [],
      dialogVisible: false,
      query: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      visible: false,
      logList: [],
      logColumns,
      countData: {}
    };
  },
  deactivated() {
  },
  methods: {
    handleClick() {
      // this.$refs.Form.rest()
      this.getDataSource();
      this.getCount()
    },
    search(formInline) {
      this.formInline = formInline;
      this.query.current = 1
      this.getDataSource();
      this.getCount()
    },
    detail(row) {
      this.dialogVisible = true;
      let that = this;
      this.$nextTick((_) => {
        this.$refs.detail.detail = row.record;
      });
    },
    print(record) {
      let Arr = [{ ...record.record, wantPrintNum: record.record.printNum }];
      if (record.record.oemMoreInboundException) {
        this.$wmsPrint.print().templatePrintByPkg(Arr, record.record.processResults)
      } else {
        this.$wmsPrint.print().templatePrintByPkg(Arr)
      }
    },
    getDataSource() {
      let params = { ...this.formInline };
      params.pageSize = this.query.pageSize;
      params.pageNum = this.query.current;
      params.pkgTypes = [3, 4];
      params.processNode = Number(this.processNode)
      if (params.processNode != '999') {
        params.wareStatus = 0
      } else {
        delete params.processNode
        params.wareStatus = 1
      }
      if (params.processNode == '1') {
        params.pkgTypes = [3, 4];
        params.serviceStatus = 0
      }
      if (params.processNode == '2') {
        params.pkgTypes = [3];
        params.serviceStatus = 0
      }
      if (params.exceptionCodes == 105) {
        params.isShortage = 1
      }
      abnormalPage(params).then(({ code, data }) => {
        if (code === 0) {
          this.datasource = data.records;
          this.query.total = data.total;
          if (params.pkgCode && data.records.length && data.records[0].serviceStatus == 1) {
            this.detail({ record: data.records[0] })
          }
        }
      });
    },
    pageChangeCall(payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getDataSource();
      this.getCount()
    },
    changePic(r) {
      this.$refs.changePic.open(r.record)
    },
    log(r) {
      const params = {
        flowCode: r.record.flowCode
      }
      recordInfo(params).then(({ code, data }) => {
        if (code === 0) {
          console.log(data)
          this.logList = data
          this.visible = true
        }
      })
    },
    getCount() {
      abnormalCount().then(res => {
        this.countData = res.data
      })
    }
  },
};
</script>

<style scoped lang="less"></style>
